import { render, staticRenderFns } from "./device-type.vue?vue&type=template&id=dd03aab2&scoped=true&"
import script from "./device-type.vue?vue&type=script&lang=ts&"
export * from "./device-type.vue?vue&type=script&lang=ts&"
import style0 from "./device-type.vue?vue&type=style&index=0&id=dd03aab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd03aab2",
  null
  
)

export default component.exports